import { type z } from 'zod';

import { unitySearchParams } from '@@containers/Search/unitySearchParams';

/** The search of placement's teasers tab */
export const teasersSearchParams = unitySearchParams.pick({
    q: true,
    tenantIds: true,
    userIds: true,
    contentType: true,
    categoryIds: true,
    tagIds: true,
});

export type TeasersSearchParams = z.output<typeof teasersSearchParams>;
